<div class="container search-bar-cont"
  [class.is-flight-results]="isFlightsResult$ | async"
  [class.is-hotel-results]="isHotelResult$ | async"
  [class.desktop-package-hotel-detail]="isHotelDetail">
  <div class="packageDestination__cont" *ngIf="!showHotelDetail">
    <ng-container *ngIf="isResultsPage">
      <ng-container *ngTemplateOutlet="backBtn"></ng-container>
    </ng-container>
    <app-packages-destination-desktop
      [isResultsPage]="isResultsPage"
      [isHotelDetail]="isHotelDetail"
      [isSubmited]="isSubmitted"
      [isOneWayTrip]="isOneWayTrip$ | async"
      [searchType]="searchType"
      [isHotelPackageView]="isHotelPackageView$ | async"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces$ | async"
      [cityAndAirportsPlaces]="autoCompletePlaces$ | async | autocompleteVm"
      [hotelOrLocationPlaces]="hotelAutoCompletePlaces$ | async"
      [destinationPlace]="packagesDestinationPlace$ | async"
      [departurePlace]="packagesOriginPlace$ | async"
      (selectPackagesDestination)="selectPackagesDestination($event)"
      (selectPackagesDeparture)="selectPackagesDeparture($event)"
      (popularAmplitudeEvent)="popularSelectedEvent($event)"
      (runAutocomplete)="runAutocomplete($event)"
      (resetAutocomplete)="resetAutocomplete()"
      (swipeAction)="swipeAction()">
    </app-packages-destination-desktop>
  </div>
  <div class="travel-calendar-cont"
    [class.results]="isSpecialInputStyles" 
    [class.is-hotel-results]="isHotelResult$ | async">
    <div class="travel-calendar-flight-type" *ngIf="viewFlighOptions$ | async">
        <span (click)="togglePackagesOption('PASSENGER_ARRANGEMENT')">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [tag]="'p'"
            [color]="fontColor.Secondary"
            [text]="passengerValue + ' ' + (passengerLabel | transloco)">
          </app-ds-typography>
          <app-ds-icon
            [icon]="icons.ChevronDown"
            [size]="16"
            [color]="iconFillColor.Secondary">
          </app-ds-icon>
        </span>
        <ng-container *ngIf="staticShowClassControls">
          <span class="flight-class" (click)="togglePackagesOption('FLIGHT_CLASSES')">
            <app-ds-typography
              [size]="fontSize.XXXS"
              [tag]="'p'"
              [color]="fontColor.Secondary"
              [text]="'SEARCH_MODULE.FLIGHT_CLASSES.' + (activeFlightClass$ | async) | transloco">
            </app-ds-typography>
            <app-ds-icon
              [icon]="icons.ChevronDown"
              [size]="16"
              [color]="iconFillColor.Secondary">
            </app-ds-icon>
          </span>
        </ng-container>
        <div [ngSwitch]="activeOption" class="flight-options-cont {{activeOption | lowercase}}" [class.active]="showDesktopSearchOptions">
          <ng-container *ngSwitchCase="'PASSENGER_ARRANGEMENT'">
            <ng-container *ngTemplateOutlet="roomsTemplate"></ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="'FLIGHT_CLASSES'">
            <ng-container *ngTemplateOutlet="classSelection"></ng-container>
          </ng-container>
        </div>
    </div>
    <div class="travel-calendar-input-cont"
      [class.is-hotel-results]="isHotelResult$ | async"
      [class.is-hotel-step]="isHotelPackageView$ | async">
      <div class="calendar-search">
        <app-search-bar-calendar
          [isOneWayTrip]="isOneWayTrip$ | async"
          [arrivalDate]="arrivalDate$ | async"
          [departurePlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_DEPARTURE' | transloco"
          [returnPlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_RETURN' | transloco"
          [departureDate]="departureDate$ | async"
          [show]="showCalendarInput"
          [fieldActivated]="dateCalendarField"
          [searchType]="searchType"
          (emitApplySelection)="applyCalendar($event)">
        </app-search-bar-calendar>
      </div>
      <app-search-bar-input
        [id]="'calendar-departure'"
        [showError]="isEmptyDepartureDate$ | async"
        [searchType]="searchType"
        [label]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_DEPARTURE' | transloco"
        [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_DEPARTURE' | transloco"
        [value]="departureDate$ | async | flightDate: showYear"
        [icon]="icons.Calendar"
        [swapPlaceholder]= true
        (isFocus)="setCalendarField('left')">
      </app-search-bar-input>
      <app-search-bar-input
        [id]="'calendar-arrival'"
        [showError]="isEmptyArrivalDate$ | async"
        [searchType]="searchType"
        [label]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_RETURN' | transloco"
        [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.PACKAGES_RETURN' | transloco"
        [value]="arrivalDate$ | async | flightDate: showYear"
        [icon]="icons.Calendar"
        [swapPlaceholder]= true
        [disabled]="isOneWayTrip$ | async"
        (isFocus)="setCalendarField('right')">
      </app-search-bar-input>
      <div class="rooms-input" [class.is-hotel-step]="isHotelPackageView$ | async" [class.is-hotel-detail]="isHotelDetail" *ngIf="viewHotelRooms$ | async">
        <ng-container *ngTemplateOutlet="roomsTemplate"></ng-container>
      </div>
    </div>
    <div class="button-container"
      [class.is-flight-results]="isFlightsResult$ | async"
      [class.is-hotel-results]="isHotelResult$ | async" 
      [class.is-hotel-detail]="isHotelDetail">
      <app-ds-button
        [showIcon]="true"
        [icon]="searchIcon"
        [size]="buttonSize"
        (clickEvent)="searchPackages()">
      </app-ds-button>
    </div>
  </div>
</div>

<ng-template #classSelection>
  <app-search-bar-passenger-selection
    [searchType]="searchType"
    [isMobile]="false"
    [activeOption]="activeOption"
    [eventPath]="eventPath | async"
    [activeFlightClass]="activeFlightClass$ | async"
    (emitApplySelection)="togglePackagesOption()"
    (emitFlightClassSelection)="setFlightClass($event)">
  </app-search-bar-passenger-selection>
</ng-template>

<ng-template #roomsTemplate>
  <app-search-bar-room
    #hotelRoomsSelectorRef
    [icon]="icons.ChevronFilledDown"
    [id]="'search-bar-hotel-room'"
    [isHome]="isHome"
    [searchType]="searchType"
    [searchBy]="searchBy"
    [label]="'HOTELS_MODULE.HOME.ROOMS_LABEL' | transloco"
    [placeholder]="'HOTELS_MODULE.HOME.ROOMS_PLACEHOLDER' | transloco"
    [control]="roomControl"
    [intialRooms]="rooms"
    [packageFlightClass]="activeFlightClass$ | async"
    [packageStep]="packageStep$ | async"
    (fetchMessageAction)="fetchMessageAction()"
    (setGuestsPerRoom)="setGuestsPerRoom($event)"
    (addNewRoom)="addRoom($event)"
    (removeRoom)="removeRoom($event)"
    (emitPackageFlightClassSelection)="setFlightClass($event)"
    (emitRoomsSelection)="closeRoomSelector($event)">
  </app-search-bar-room>
</ng-template>

<ng-template #backBtn>
  <div class="go-back-btn-container" [class.is-flight-back]="isFlightsResult$ | async">
    <a class="back-span" (click)="back()">
      <app-ds-icon
        [icon]="icons.ChevronLeft"
        [size]="16"
        [color]="iconFillColor.Primary">
      </app-ds-icon>
      <app-ds-typography
        [size]="fontSize.XXS"
        [tag]="'p'"
        [fontFamily]="fontFamily.SemiBold"
        [color]="fontColor.Primary"
        [text]="'BACK' | transloco">
      </app-ds-typography>
    </a>
  </div>
</ng-template>